const YANDEX_ID = import.meta.env.VITE_YANDEX_METRIKA_ID;

export const sendAim = (aimName) => {
    if (!YANDEX_ID || YANDEX_ID === "0") {
        console.warn("Yandex Metrika ID is not set — goal not sent:", aimName);
        return;
    }

    if (typeof window.ym === "function") {
        window.ym(YANDEX_ID, "reachGoal", aimName);
    } else {
        console.warn("Yandex Metrika is not initialized.");
    }
};
